import React from "react";
import { inject, observer } from "mobx-react";
import { UiFlagsStore } from "../../stores/uiFlagsStore";
import BackButton from "../sharedComponents/backButton/backButton";
import { Widget } from "../../helpers/widget";
import { RisksNetworkTypes } from "../../helpers/risksNetwork";
import InsurerData from "./insurerData/insurerData";
import "./contractData.scss";
import Header from "../sharedComponents/header/header";
import NextButton from "../sharedComponents/nextButton/nextButton";
import { ErrorMessage, ErrorMessages } from "../../helpers/errorMessage";
import { ClientStore } from "../../stores/clientStore";
import { PolicyStore } from "../../stores/policyStore";
import { CalculateStore } from "../../stores/calculateStore";
import { ProposalStore } from "../../stores/proposalStore";
import SummaryBox from "../sharedComponents/summaryBox/summaryBox";
import EstateData from "./estateData/estateData";
import DistancePolicy from "./insurerData/distancePolicy/distancePolicy";
import PaymentMethod from "./paymentMethod/paymentMethod";
import { Popup } from "../sharedComponents/popup/popup";
import ProgressBar from "../sharedComponents/progressBar/progressBar";
import NnwClients from "./nnwClients/nnwClients";
import Consents from "./consents/consents";
import { HttpError } from "../sharedComponents/notification/httpError";
import { CalculationService } from "../../services/services/calculationService";
import { UserRole } from "../../helpers/userRole";
import { UserStore } from "../../stores/userStore";
import CatsAndDogs from "./catAndDog/catsAndDogs";
import Gravestone from "./gravestone/gravestone";
import CessionBank from "./cession/cessionBank";
import SafeSenior from "./safeSenior/safeSenior";
import IssuePlace from "./issuePlace/issuePlace";
import SaveCalculationButton from "../sharedComponents/saveCalculationButton/saveCalculationButton";
import { StoreCalculationService } from "../../services/services/storeCalculationService";
import StoreCalculationPopup from "../offerCustomizer/storeCalculationPopup/storeCalculationPopup";
import InsuredInSecondOpinion from "./insuredInSecondOpinion/insuredInSecondOpinion";
import Insureds from "../sharedComponents/insureds/insureds";
import DownloadDocuments from "../sharedComponents/downloadDocuments/downloadDocuments";
import { FilesKeys } from "../../stores/documentStore";
import { onSaveCalculationButtonClick } from "../../helpers/calculation";
import { PolicyService } from "../../services/services/policyService";
import { ProposalService } from "../../services/services/proposalService";
import ClientEndsPopup from "./clientEndsPopup/clientEndsPopup";
import { ClientEndsService } from "../../services/services/clientEndsService";
import Loader from "../sharedComponents/loader/Loader";
import Notification from "../sharedComponents/notification/notification";
import {RemotePaymentLinkService} from "../../services/services/remotePaymentLinkService";
import SaveCalculationExceededProxiesButton
  from "../sharedComponents/saveCalculationExceededProxiesButton/saveCalculationExceededProxiesButton";
import {UwRulesService} from "../../services/services/sendforapproval";
import ReactGA from "react-ga4";

interface ContractDataProps {
  calculateStore?: CalculateStore;
  proposalStore?: ProposalStore;
  clientStore?: ClientStore;
  uiFlagsStore?: UiFlagsStore;
  policyStore?: PolicyStore;
  userStore?: UserStore;
  calculationService?: CalculationService;
  proposalService?: ProposalService;
  storeCalculationService?: StoreCalculationService;
  policyService?: PolicyService;
  clientEndsService?: ClientEndsService;
  remotePaymentLinkService?: RemotePaymentLinkService;
  uwRulesService?: UwRulesService;
}

interface ContractDataState {
  popupIsOpen: boolean;
  popupMessage: string;
  progressValue: number;
  maxProgressValue: number;
  displayProgressBar: boolean;
  displayAction: boolean;
  numberOfCalculationRequest: number;
  nextButtonWasClicked: boolean;
  isSaveOffer: boolean;
  documentsDownload: boolean;
  documentsDownloadMessage: boolean;
  isStorePopupOpen: boolean;
  isClientEndsPopupOpen: boolean;
  loadCalculation: boolean;
}

@inject("uiFlagsStore", "clientStore", "proposalStore", "policyStore", "calculateStore", "userStore",
  "calculationService", "proposalService", "storeCalculationService", "policyService", "clientEndsService", "remotePaymentLinkService", "uwRulesService")
@observer
export default class ContractData extends React.Component<ContractDataProps, ContractDataState> {
  private limitOfCalculationRequest: number = 2;

  private REMOTE_SALE_EXCEEDED_PROXIES_NOTIFICATION_MSG: string = "Oferta wymaga akceptacji przekroczonego pełnomocnictwa, w związku z tym mail do Klienta z ofertą zdalną zostanie wysłany automatycznie po zaakceptowaniu przekroczonych pełnomocnictw przez TUZ Ubezpieczenia.";

  private defaultTimeOut:number = 1800;
  constructor(props: any) {
    super(props);

    this.state = {
      ...this.defaultPopupValues(),
      numberOfCalculationRequest: 0,
      nextButtonWasClicked: false,
      documentsDownload: !this.props.uiFlagsStore!.isDirect,
      documentsDownloadMessage: false,
      isSaveOffer: false,
      isStorePopupOpen: false,
      loadCalculation: false,
      isClientEndsPopupOpen: false
    };

    if (this.isDistancePolicyRequired()) {
      this.props.proposalStore!.distancePolicy.setValue(true);
    }
  }

  public async componentDidMount() {
    this.setState({ loadCalculation: true });
    await this.executeCalculationWithSaving();

    if (this.state.nextButtonWasClicked) {
      await this.executeRequests(this.isExceededProxies());
      this.setState({ nextButtonWasClicked: false });
    }
    this.setState({ loadCalculation: false });

    this.handleGaTag("contractDataEntry");
  }

  public render() {
    return (
      <div
        className={`content contract-data ${this.props.uiFlagsStore!.isMobile ? "" : "display-flex"}`}>
        {this.state.loadCalculation && this.renderLoader()}
        <div className="left-column">
          <Header type="big" mainHeader="Dane do zawarcia umowy" />
          {this.renderHttpError()}
          {this.isExceededProxiesForRemoteSale() && <Notification
              type={"info-bold"} message={this.REMOTE_SALE_EXCEEDED_PROXIES_NOTIFICATION_MSG} />}
          {this.displayDistancePolicy() && (
            <DistancePolicy isDistancePolicyRequired={this.isDistancePolicyRequired()} />
          )}
          {this.props.calculateStore!.propertyInsuranceOrOcChecked && <EstateData />}
          <InsurerData />
          <Insureds disabled={true} displayAddressForm={true} className="section" />
          {this.displaySecondOpinion() && <InsuredInSecondOpinion />}
          {this.props.calculateStore!.propertyInsurance && <CessionBank />}
          <Gravestone />
          <NnwClients />
          <SafeSenior />
          <CatsAndDogs />
          {this.displayWhenClientEndsNotSelected() && (
            <>
              <PaymentMethod />
              {!this.props.uiFlagsStore!.isDirect && <IssuePlace />}
              <Consents />
            </>
          )}
          {this.props.uiFlagsStore!.isMobile && (
            <SummaryBox exceededProxies={!this.isExceededProxies()}
              exceededProxiesForRemoteSale={this.isExceededProxiesForRemoteSale()}
              displayLoader={false} />
          )}
          {this.renderButtons()}
        </div>
        {!this.props.uiFlagsStore!.isMobile && (
          <SummaryBox exceededProxies={!this.isExceededProxies()}
            exceededProxiesForRemoteSale={this.isExceededProxiesForRemoteSale()}
            displayLoader={false}>
            {this.renderCheckData()}
            {this.renderNextButton(false)}
            {this.renderSaveOfferExceededProxiesButton()}
          </SummaryBox>
        )}

        <StoreCalculationPopup
          isOpen={this.state.isStorePopupOpen}
          parentCalculationId={this.props.calculateStore!.parentCalculationId}
          waitForParentCalculationId={true}
          onClose={() => this.setState({ isStorePopupOpen: false })}
        />
        <ClientEndsPopup
          isOpen={this.state.isClientEndsPopupOpen}
          onClose={() => this.setState({ isClientEndsPopupOpen: false })}
          onAction={() => this.clientEndsAction()}
        />
        <Popup open={this.state.popupIsOpen}
          changeOpenProp={this.changeDialogOpen.bind(this)}
          actionText="Zamknij"
          displayAction={this.state.displayAction}
          action={() => {
            this.setStatePopup("default");
          }}
          dialogContent={
            <div className={`progress-bar-container`}>
              <div className="message">{this.state.popupMessage}</div>
              {this.state.displayProgressBar && (
                <ProgressBar
                  value={this.state.progressValue}
                  maxValue={this.state.maxProgressValue}
                />
              )}
            </div>
          }
        />
      </div>
    );
  }

  private renderLoader() {
    return <div className="offer-loader">
      <Loader />
      <div className="offer-loader-message">Ładowanie...</div>
    </div>;
  }

  private displaySecondOpinion() {
    const checked = this.props.calculateStore!.additionalInsurances.secondOpinion.checked;
    const networkValue = this.props.calculateStore!.additionalInsurances.secondOpinion.risksNetworkValue;
    return networkValue === RisksNetworkTypes.required
      || (networkValue === RisksNetworkTypes.available && checked);
  }

  private renderNextButton(isSaveOffer: boolean) {
    const tryPolicy = this.isExceededProxies();
    const buttonType = this.properButtonType(isSaveOffer);

    return (
      <NextButton
        displayLoader={false}
        onClick={() => this.nextButtonOnClick(tryPolicy, isSaveOffer)}
        buttonType={buttonType}
        disabledColor={!this.state.documentsDownload}
      />
    );
  }
  private renderSaveOfferExceededProxiesButton(){
    return(
        <SaveCalculationExceededProxiesButton onClick={()=>this.executeProposalAndUwRulesApproval()} exceededProxies={this.isExceededProxies()}/>
    );
  }

  private renderButtons() {
    const directPolicy = this.props.uiFlagsStore!.isDirect;
    return (
      <div
        className={`${UserRole.isEurofinanceRole(this.props.userStore!.roles) ? "eurofinance-buttons" : ""}`}>
        {this.renderCheckData()}
        <div className={`buttons ${directPolicy ? "buttons-direct" : ""}`}>
          <BackButton onClick={() => this.backButtonOnClick()} />
          {directPolicy
            ? <DownloadDocuments
              buttonLabel="Pobierz Kartę produktu, OWU i Formularz informacyjny"
              downloadFiles={[FilesKeys.productCard, FilesKeys.generalTermsAndConditions, FilesKeys.informationForm]}
              displayPolicyInfo={this.state.documentsDownloadMessage}
              onClick={(success: boolean) => {
                if (success) {
                  this.setState({
                    documentsDownload: true,
                    documentsDownloadMessage: false
                  });
                }
              }}
            />
            : <SaveCalculationButton
              onClick={() => {
                onSaveCalculationButtonClick(this.props.storeCalculationService!, this.props.clientStore!);
                this.setState({ isStorePopupOpen: true });
              }} />
          }
          {(UserRole.isEurofinanceRole(this.props.userStore!.roles)) && (
              this.renderNextButton(true)
          )}
          {(UserRole.isEurofinanceRole(this.props.userStore!.roles) && this.isExceededProxies()) && (
              this.renderNextButton(false)
          )}
          {(!UserRole.isEurofinanceRole(this.props.userStore!.roles) && (
              this.renderNextButton(false))
          )}
          {this.renderSaveOfferExceededProxiesButton()}
        </div>
      </div>
    );
  }

  private renderHttpError() {

    if (this.saveCalculationRequestHasError()) {
      return <HttpError defaultErrorMessage={ErrorMessages.response.saveCalculation}
        requestStatuses={[this.props.calculateStore!.saveCalculationRequestStatus]}
        type={"http"} />;
    } else if (this.props.proposalStore!.proposalRequestStatus.isError && this.state.isSaveOffer) {
      return <HttpError defaultErrorMessage={ErrorMessages.response.saveOffer}
        requestStatuses={[this.props.proposalStore!.proposalRequestStatus]}
        type={"http"} />;
    } else if (this.props.proposalStore!.proposalRequestStatus.isError) {
      return <HttpError defaultErrorMessage={ErrorMessages.response.proposal}
        requestStatuses={[this.props.proposalStore!.proposalRequestStatus]}
        type={"http"} />;
    } else if (this.props.policyStore!.policyRequestStatus.isError) {
      return <HttpError defaultErrorMessage={ErrorMessages.response.policy}
        requestStatuses={[this.props.policyStore!.policyRequestStatus]}
        type={"http"} />;
    } else if (this.props.clientStore!.generateClientEndsLinkRequestStatus.isError) {
      return <HttpError defaultErrorMessage={ErrorMessages.response.generateClientEndsLink}
        requestStatuses={[this.props.clientStore!.generateClientEndsLinkRequestStatus]}
        type={"http"} />;
    }
  }

  private renderCheckData() {
    let message = "Sprawdź poprawność wprowadzonych danych, przed kliknięciem ";

    message += this.isExceededProxies() ?
      (this.props.uiFlagsStore!.isClientEndsSelected ? `"Wyślij ofertę"` : `"Wystaw polisę"`) :
      `"Zapisz ofertę"`;

    message += ".";

    return (
      <>
        {this.state.documentsDownload && (
          <div className="check-data">
            {message}
          </div>
        )}
      </>
    );

  }

  private backButtonOnClick() {
    this.resetRequestsStatuses();
    Widget.goToPrevStep(this.props.uiFlagsStore!);
    this.clearErrorMessage();
  }

  private async nextButtonOnClick(tryPolicy: boolean, saveOffer: boolean) {
    this.setState({ isSaveOffer: saveOffer });

    if (!this.state.documentsDownload) {
      this.setState({ documentsDownloadMessage: true });
      Widget.scrollToClass("download-button-wrapper");
    } else {
      this.validateForm();
      this.setStatePopup("default");

      if (ErrorMessage.verifyIfFormErrorMessageIsRendered()) {
        ErrorMessage.scrollToFirstFormErrorMessage();
      } else {
        if (ErrorMessage.verifyIfErrorMessageIsRendered()) {
          ErrorMessage.scrollToFirstErrorMessage();
        }

        if (this.isClientEndsSelected() && tryPolicy) {
          this.props.clientStore!.setEmailForClientEnds(this.props.clientStore!.insurer.email.value || "");
          this.openClientEndsPopup();
        } else {
          await this.executeRequests(tryPolicy);
        }
      }
    }
  }

  private async executeRequests(tryPolicy: boolean) {
    const calculateStore = this.props.calculateStore!;
    const proposalStore = this.props.proposalStore!;
    const policyStore = this.props.policyStore!;
    const clientStore = this.props.clientStore!;

    if (calculateStore.saveCalculationRequestStatus.isPending) {
      this.setStatePopup("calculation");

      this.setState({ nextButtonWasClicked: true });
    } else if (!calculateStore.calculationResponse?.calculationId
      || proposalStore.proposalResponse?.proposalId
      || policyStore.policyResponse?.policyId) {

      this.setStatePopup("calculation");
      await this.executeCalculationWithSaving();
      tryPolicy = this.isExceededProxies();
    }

    const calculationId = calculateStore.calculationResponse?.calculationId;
    if (calculateStore.saveCalculationRequestStatus.isDone && !calculateStore.saveCalculationRequestStatus.isError && calculationId) {
      this.setStatePopup(this.state.isSaveOffer ? "offer" : "proposal");
      await this.executeProposal();
      if (this.props.uiFlagsStore!.isDirect && this.isExceededProxies()){
        await this.executeGenerateRemotePaymentLink();
        this.handleGaTag("offerSentAndRediectUserToPayment");
        return;
      }
      if (this.isExceededProxiesForRemoteSale() && this.props.clientStore) {
        const email = this.props.clientStore.insurer?.email?.value || "";
        this.props.clientStore.setEmailForClientEnds(email);

        try {
          await this.executeClientEnds();
        } catch (error) {
          // @NOTE: logowanie do konsoli tylko do testow
          // console.error("Error in executeClientEnds():", error);
        }
      }
      const proposalId = proposalStore.proposalResponse?.proposalId;
      if (proposalStore.proposalRequestStatus.isDone && !proposalStore.proposalRequestStatus.isError && proposalId) {
        if (this.state.isSaveOffer) {
          this.setState({ progressValue: 100, maxProgressValue: 100 }, () => {
            setTimeout(() => {
              this.setStatePopup("saved");
              this.isExceededProxies()?
                  this.goToNextStep(): this.props.uiFlagsStore!.goToProxiesExceededPage();
            }, this.defaultTimeOut);
          });
        } else if (!tryPolicy) {
          this.props.uiFlagsStore!.goToProxiesExceededPage();
        } else {
          if (this.isClientEndsSelected()) {
            this.setStatePopup("clientEnds");
            await this.executeClientEnds();

            if (clientStore.generateClientEndsLinkRequestStatus.isDone && !clientStore.generateClientEndsLinkRequestStatus.isError) {
              this.setState({ progressValue: 100 });

              setTimeout(() => {
                this.setStatePopup("default");
                this.goToNextStep();
              }, this.defaultTimeOut);
            }
          } else {
            this.setStatePopup("policy");
            await this.executePolicy();
            if (this.props.policyStore!.policyRequestStatus.isProxiesExceeded) {
              this.props.uiFlagsStore!.goToProxiesExceededPage();
            } else {
              const policyId = policyStore.policyResponse?.policyId;

              if (policyStore.policyRequestStatus.isDone && !policyStore.policyRequestStatus.isError && policyId) {
                this.setState({ progressValue: 100 });

                setTimeout(() => {
                  this.setStatePopup("default");
                  this.goToNextStep();
                }, this.defaultTimeOut);
              }
            }
          }
        }
      }
    }

    if (this.saveCalculationRequestHasError()
      || proposalStore.proposalRequestStatus.isError
      || policyStore.policyRequestStatus.isError
      || clientStore.generateClientEndsLinkRequestStatus.isError) {

      this.setStatePopup("default");
      ErrorMessage.scrollToFirstErrorMessage();
    }
  }

  private clearErrorMessage() {
    this.props.proposalStore!.distancePolicy.clearValidation();
    this.props.clientStore!.insureds.forEach(
      (insured) => {
        insured.clearErrorMessages();
      });
    this.props.proposalStore!.nnw.clients.forEach(
      (client) => {
        client.clearErrorMessages();
      });
    this.props.proposalStore!.catAndDog.clearErrorMessages();
    this.props.proposalStore!.safeSenior.clearErrorMessages();
  }

  private goToNextStep() {
    Widget.goToNextStep(this.props.uiFlagsStore!);
  }

  private async executeCalculationWithSaving(): Promise<void> {
    this.setState({ numberOfCalculationRequest: this.state.numberOfCalculationRequest + 1 });
    return this.props.calculationService!.recalculateAndStore(this.handleError);
  }

  private executeProposal() {
    const calculateStore = this.props.calculateStore!;
    const proposalStore = this.props.proposalStore!;
    const calculationId = calculateStore.parentCalculationId;

    if (calculationId) {
      return this.props.proposalService!.requestProposal(calculationId).then((resp) => {
        proposalStore.setProposalResponse(resp);
      }).catch((error) => {
        this.handleError(error);
      });
    }
  }

  private executePolicy() {
    const proposalStore = this.props.proposalStore!;
    const policyStore = this.props.policyStore!;
    const proposalId = proposalStore.proposalResponse.proposalId;

    if (proposalId) {
      return this.props.policyService!.requestPolicy({ proposalId }).then((resp) => {
        policyStore.setPolicyResponse(resp);
      }).catch((error) => {
        this.handleError(error);
      });
    }
  }

  private executeClientEnds() {
    const proposalId = this.props.proposalStore!.proposalResponse.proposalId;
    const accountNumber = this.props.proposalStore!.proposalResponse.accountNumber;
    const clientStore = this.props.clientStore!;
    const contactCity = this.getContactCity();
    const exceededProxies = !this.isExceededProxies();
    if (proposalId) {
      return this.props.clientEndsService!.generateClientEndsLink(proposalId, clientStore.emailForClientEnds.value, exceededProxies, accountNumber, contactCity)
        .catch((error) => {
          this.handleError(error);
        });
    }
  }
  private async executeGenerateRemotePaymentLink() {
    const proposalId = this.props.proposalStore!.proposalResponse.proposalId;
    const accountNumber = this.props.proposalStore!.proposalResponse.accountNumber;
    const email = this.props.clientStore!.insurer.email.value;
    const contactCity = this.getContactCity();
    if (proposalId) {
      try {
        const response = await this.props.remotePaymentLinkService!.generateRemotePaymentLink(
            proposalId, accountNumber, email, contactCity
        );
        window.open(response.remoteUrl, "_self");
      } catch (error) {
        this.handleError(error);
        this.setStatePopup("paymentError");
      }
    }
  }
  private async executeUwRulesApproval() {
    const proposalId = this.props.proposalStore!.proposalResponse.proposalId.toString();
    if (proposalId) {
      try {
        await this.props.uwRulesService?.sendForApproval(
            proposalId
        );
      } catch (error) {
        this.handleError(error);
      }
    }
  }


  private getContactCity(): string {
    const regon = this.props.clientStore?.clients[0].regon.value!;

    return this.isCompany(regon) ? this.getConntactCityForNonCompany() : this.getConntactCityForCompany();
  }

  private isCompany(regon: string): boolean {
    return regon === "";
  }

  private getConntactCityForCompany(): string {
    return this.props.clientStore?.clients[0].companyAddressTheSame ? this.props.calculateStore?.estate.address.city.value! :
      this.props.clientStore?.clients[0].companyAddress.city.value!;
  }

  private getConntactCityForNonCompany(): string {
    return this.props.clientStore?.clients[0].contactAddressTheSame
      ? (this.props.clientStore?.clients[0].personAddressTheSame && this.props.calculateStore?.propertyInsurance
        ? this.props.calculateStore?.estate.address.city.value! : this.props.clientStore?.clients[0].personAddress.city.value!)
      : this.props.clientStore?.clients[0].contactAddress.city.value!;
  }

  private handleError(error: any) {
    // tslint:disable-next-line:no-console
    console.log("Błąd: ", error);
  }

  private validateForm() {
    this.props.proposalStore!.distancePolicy.validate();
    this.validateInsuredsData();
    this.validateInsurerData();
    this.validateNnw();
    this.props.proposalStore!.cession.validate();
    this.props.proposalStore!.validateRequiredConsents(this.props.calculateStore!, this.props.uiFlagsStore!.isDirect);
    this.props.proposalStore!.catAndDog.validate();
    this.props.proposalStore!.gravestone.validate();
    this.props.proposalStore!.safeSenior.validate();
    this.props.proposalStore!.issuePlace.validate();
  }

  private validateNnw() {
    this.props.proposalStore!.nnw.clients.forEach(
      (client) => {
        client.validateClientData();
      });
  }

  private validateInsuredsData() {
    this.props.clientStore!.insureds.forEach(
      (insured) => {
        insured.validateAddress();
        insured.regon?.validate();
        insured.firstName.validate();
        insured.lastName.validate();
        insured.pesel.validate();
        insured.validateCompanyName();
      });
  }

  private validateInsurerData() {
    const contactDataRequired = this.props.uiFlagsStore!.isDirect || this.props.uiFlagsStore!.isClientEndsSelected;

    this.props.clientStore!.insurer?.validateAddress();
    this.props.clientStore!.insurer.validatePhoneNumber(contactDataRequired);
    this.props.clientStore!.insurer.validateEmail(contactDataRequired);
  }

  private changeDialogOpen() {
    this.setState({ popupIsOpen: !this.state.popupIsOpen });
  }

  private defaultPopupValues() {
    return {
      popupIsOpen: false,
      popupMessage: "",
      progressValue: 0,
      maxProgressValue: 0,
      displayProgressBar: true,
      displayAction: false
    };
  }

  private resetRequestsStatuses() {
    const proposalStore = this.props.proposalStore!;
    const policyStore = this.props.policyStore!;
    const calculateStore = this.props.calculateStore!;
    const clientStore = this.props.clientStore!;

    proposalStore.proposalRequestStatus.reset();
    policyStore.policyRequestStatus.reset();
    calculateStore.saveCalculationRequestStatus.reset();
    clientStore.generateClientEndsLinkRequestStatus.reset();
    clientStore.generateRemotePaymentLinkRequestStatus.reset();
  }

  private setStatePopup(requestType: "calculation" | "proposal" | "policy" | "offer" | "saved" | "clientEnds" | "default" | "paymentError" ) {
    let maxProgressValue = 0;
    let popupMessage = "";
    let progressValue = 0;
    let popupIsOpen = true;
    let displayAction = false;

    switch (requestType) {
      case "calculation":
        progressValue = 0;
        maxProgressValue = 20;
        popupMessage = "Trwa zapisywanie kalkulacji...";
        break;
      case "proposal":
        progressValue = 20;
        maxProgressValue = 60;
        popupMessage = "Trwa zapisywanie wniosku...";
        break;
      case "policy":
        progressValue = 60;
        maxProgressValue = 100;
        popupMessage = "Trwa wystawianie polisy...";
        break;
      case "clientEnds":
        progressValue = 60;
        maxProgressValue = 100;
        popupMessage = "Trwa wysyłanie oferty do klienta...";
        break;
      case "offer":
        progressValue = 20;
        maxProgressValue = 95;
        popupMessage = "Trwa zapisywanie oferty...";
        break;
      case "saved":
        progressValue = 100;
        maxProgressValue = 100;
        displayAction = true;
        popupMessage = "Zapisano ofertę";
        break;
      case "paymentError":
        progressValue = 100;
        maxProgressValue = 100;
        displayAction = true;
        popupMessage = "Wystąpił nieoczekiwany błąd. Kliknij ponownie przycisk \"Kupuję z obowiązkiem zapłaty\".";
        break;
      default:
        ({
          popupIsOpen,
          popupMessage,
          progressValue,
          maxProgressValue,
          displayAction
        } = this.defaultPopupValues());
    }

    this.setState({
      popupIsOpen,
      popupMessage,
      progressValue,
      maxProgressValue,
      displayAction
    });
  }

  private saveCalculationRequestHasError() {
    return this.props.calculateStore!.saveCalculationRequestStatus.isError
      && this.state.numberOfCalculationRequest >= this.limitOfCalculationRequest;
  }

  private displayDistancePolicy() {
    return UserRole.isDistancePolicyRole(this.props.userStore!.roles) && !this.props.uiFlagsStore!.isDirect && !this.isClientEndsSelected();
  }

  private isDistancePolicyRequired() {
    return UserRole.isDistancePolicyRequiredRole(this.props.userStore!.roles) || this.props.uiFlagsStore!.isDirect;
  }

  private isExceededProxies() {
    return !this.props.calculateStore!.calculationResponse?.exceededProxies;
  }

  private isExceededProxiesForRemoteSale() {
    const calculateStore = this.props.calculateStore!;
    const exceededProxies = calculateStore.calculationResponse?.exceededProxies;
    return !!(exceededProxies && exceededProxies.length !== 0) && this.isRemoteSaleClient() && this.isClientEndsSelected();
  }

  private isRemoteSaleClient() {
    return this.props.uiFlagsStore!.displayClientEnds(this.props.userStore!.roles);
  }

  private properButtonType(saveOfferForEf: boolean) {
    if (saveOfferForEf) {
      return "save-offer-for-ef";
    }

    const directPolicy = this.props.uiFlagsStore!.isDirect;
    const tryPolicy = this.isExceededProxies();

    return tryPolicy ? (this.isClientEndsSelected() ? "client-ends-contract-data" : (directPolicy ? "policy-direct" : "policy")) : "save-offer";
  }

  private displayWhenClientEndsNotSelected() {
    return !this.isClientEndsSelected();
  }

  private isClientEndsSelected() {
    return this.props.uiFlagsStore!.isClientEndsSelected;
  }
  private openClientEndsPopup() {
    this.setState({ isClientEndsPopupOpen: true });
  }

  private async clientEndsAction() {
    this.setState({ isClientEndsPopupOpen: false });
    await this.executeRequests(this.isExceededProxies());
  }

  public async executeProposalAndUwRulesApproval() {
    this.validateForm();
    this.setStatePopup("default");

    if (ErrorMessage.verifyIfFormErrorMessageIsRendered()) {
      ErrorMessage.scrollToFirstFormErrorMessage();
    } else {
      try {
        this.setStatePopup("proposal");
        await this.executeProposal();
        if (this.isExceededProxiesForRemoteSale()) {
          this.props.clientStore!.setEmailForClientEnds(this.props.clientStore!.insurer.email.value || "");
          await this.executeClientEnds();
        }
        await this.executeUwRulesApproval();
        this.props.uiFlagsStore!.goToProxiesExceededPage();
      } catch (error) {
        this.handleError(error);
      }
    }
  }
  private handleGaTag(action: string) {
    if (this.props.uiFlagsStore?.isDirect) {
      ReactGA.event({category: "event", action: `${action}`});
    }
  }
}
